import React from "react";

import Header from "./Components/Common/Header/Index";
import QuestionSection from "./Components/QuestionSection/Index";
import { surveyapi } from "./APIs/API";
import { getParameterByName, token } from "./Utils/Function";
import UserModal from "./Components/UserModal";
import { surveyurl } from "./Utils/Bootstrap";
import CleverTapSdk from "./CleverTapSdk";
export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionList: [],
      title: "",
      index: 0,
      is_last: 0,
      finalMessage: "",
      error: 0,
      errorMessage: "",
      currentQuestion: {},
      isLoading: true,
      allDetailsData: {},
      visible: true,
      score: 0,
      totalTime: 0,
      durations: "0",
    };
  }
  componentDidMount() {
    this.getDetailsData();
    this.setState({ isLoading: false });
    this.CTEventData("", "Started");
  }

  CTEventData = async (questionid = null, type = "Attamped") => {
    let ctdata = {};
    ctdata["mkbsurvey_action"] = type;
    ctdata["surveyid"] = await getParameterByName("quizid");
    if (questionid) {
      ctdata["questionid"] = questionid;
    }
    CleverTapSdk.handleEventtracking(ctdata, "Mkb Quiz 2021");
  };

  // getDetailsData = async (lang = "en") => {
  getDetailsData = async () => {
    let data = new FormData();

    let userid = await getParameterByName("userid");
    let quizid = await getParameterByName("quizid");
    let lang = await getParameterByName("lang");
    if (!quizid) {
      this.setState({ error: 1, errorMessage: "Invalid Quiz" });
    } else if (!userid) {
      this.setState({ error: 1, errorMessage: "Invalid User" });
    } else {
      let quizToken = await this.getUniqueID(quizid);
      localStorage.setItem("quiz_token", quizToken);

      data.append("action", "quizdetail");
      data.append("survey_id", quizid);
      data.append("quiz_token", localStorage.getItem("quiz_token"));
      data.append("lang", lang);
      if (userid) {
        data.append("userid", userid);
        data.append("addressid", userid);
        // this.getUserDetails(userid);
      } else {
        data.append("token", token);
      }

      let surveyapicall = surveyapi.survey(data, surveyurl);
      let thisVar = this;
      surveyapicall.done((response) => {
        let resObj = JSON.parse(response);
        if (resObj._resultflag === "1") {
          thisVar.setState({
            allDetailsData: resObj,
            title: resObj.survey_title,
            questionList: resObj.data,
            currentQuestion: resObj.data[this.state.index],
            share_text: resObj.survey_share_text,
            complete_msg: resObj.survey_complete_message,
            survey_desc: resObj.survey_desc,
          });
        } else {
          thisVar.setState({ error: 1, errorMessage: resObj.message });
        }
      });
    }
  };

  getUniqueID = async (quizid) => {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return quizid + "_" + Math.random().toString(36).substr(2, 9);
  };

  hideModal = () => {
    this.setState({ visible: false });
  };

  saveUserCard = async (canvas_url) => {
    try {
      canvas_url = canvas_url.replace("?www.facebook.com=1", "");
    } catch (error) {}
    let userid = await getParameterByName("userid");
    let quizid = await getParameterByName("quizid");
    let data = new FormData();
    data.append("action", "updatecanvas");
    data.append("survey_id", quizid);
    data.append("platform", "pwa");
    data.append("canvas_url", canvas_url);
    if (userid) {
      data.append("userid", userid);
      data.append("addressid", userid);
    } else {
      data.append("token", token);
    }
    data.append("quiz_token", localStorage.getItem("quiz_token"));
    surveyapi.survey(data, surveyurl);
  };

  submitAction = async (
    index,
    selectedOption,
    selectedOptionTitle = "",
    durations
  ) => {
    this.setState({ isLoading: true });
    let isLastQues = 0;
    let userid = await getParameterByName("userid");
    let quizid = await getParameterByName("quizid");
    setTimeout(() => {
      if (index == parseInt(this.state.questionList.length - 1)) {
        isLastQues = 1;
      }
      /**Quiz completed in time */
      let completedIn = "";
      if (isLastQues == 1) {
        let milisec = performance.now() - localStorage.getItem("quizStartTime");
        let totalSec = parseInt(Math.floor(milisec / 1000));
        // let minutes = Math.floor(milisec / 60000);
        // let seconds = ((milisec % 60000) / 1000).toFixed(0);
        // completedIn = minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
        completedIn = totalSec;
      }
      let questionDetails = this.state.currentQuestion;
      //Event tracking
      this.CTEventData(questionDetails.survey_question_id);

      let data = new FormData();
      data.append("action", "postuserquiz");
      data.append("survey_id", quizid);
      data.append("is_last", isLastQues);
      data.append("q_duration", completedIn);

      if (userid) {
        data.append("userid", userid);
        data.append("addressid", userid);
      } else {
        data.append("token", token);
      }
      data.append("quiz_token", localStorage.getItem("quiz_token"));
      data.append("lang", localStorage.getItem("lang"));

      let answers = {
        survey_options_id: selectedOption,
        survey_question_id: questionDetails.survey_question_id,
        survey_options: selectedOptionTitle || "",
        survey_question_type: "radio" || "",
        survey_question_is_mandatory:
          questionDetails.survey_question_is_mandatory || "0",
      };
      data.append("answers", JSON.stringify([answers]));
      let surveyapicall = surveyapi.survey(data, surveyurl);

      let thisVar = this;
      surveyapicall.done((response) => {
        let resObj = JSON.parse(response);
        thisVar.setState({ isLoading: false });
        if (resObj._resultflag === "1") {
          if (resObj.message_detail) {
            thisVar.setState(
              {
                is_last: 1,
                score: resObj.score,
                finalMessage: resObj.message_detail,
                currentQuestion: {},
              },
              () => {
                this.setIndex(thisVar.state.index, durations);
              }
            );
          } else {
            this.setIndex(thisVar.state.index, durations);
          }
        }
      });
    }, 1000);
  };

  setIndex = (index, durations) => {
    let incIndex = 1;

    this.setState({ index: index + incIndex }, () => {
      if (this.state.index === this.state.questionList.length) {
        this.setState(
          {
            is_last: 1,
            finalMessage: this.state.finalMessage,
            currentQuestion: {},
            durations: durations,
          },
          () => {
            this.CTEventData("", "Completed");
          }
        );
      } else {
        this.setState({
          currentQuestion: this.state.questionList[this.state.index],
          durations: durations,
        });
      }
    });
  };
  //Show dot on top gree and red
  // setUserResInCurrentQuestion = (bol, serveyid) => {
  //     let questionListDots = this.state.questionList;
  //     questionListDots.map((itm) => {
  //         if (itm["survey_question_id"] == serveyid) {
  //             itm["userAns"] = bol;
  //         }
  //     });
  //     this.setState({
  //         questionListDots: questionListDots,
  //     });
  // };

  render() {
    let {
      questionList,
      error,
      errorMessage,
      isLoading,
      currentQuestion,
      index,
      is_last,
      finalMessage,
      allDetailsData,
      title,
      complete_msg,
      survey_desc,
      visible,
      durations,
    } = this.state;
    if (error) {
      return (
        <div className="quiz_bg">
          <div className="quiz_score">
            <h3>{errorMessage}</h3>
          </div>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className="quiz_bg">
          {visible && (
            <UserModal
              hideModal={this.hideModal}
              title={title}
              complete_msg={complete_msg}
              survey_desc={survey_desc}
              getDetailsData={this.getDetailsData}
            />
          )}
          <React.Fragment>
            {is_last !== 1 && <Header title={title} />}
            {!visible && questionList.length > 0 && (
              <QuestionSection
                submitAction={this.submitAction}
                question={currentQuestion}
                index={index}
                is_last={is_last}
                finalMessage={finalMessage}
                allDetailsData={allDetailsData}
                saveUserCard={this.saveUserCard}
                score={this.state.score ? this.state.score : 0}
                share_text={this.state.share_text}
                complete_msg={this.state.complete_msg}
                setUserResInCurrentQuestion={this.setUserResInCurrentQuestion}
                durations={durations}
              />
            )}
          </React.Fragment>
        </div>
        <div
          id="divLoading"
          style={{ display: isLoading ? "block" : "none" }}
        ></div>
      </React.Fragment>
    );
  }
}
